import { Type } from 'class-transformer';
import { WFReimbursementRequestLineItemsResultDto } from './wf-reimbursement-request-line-items-result-dto';
import { WFReimbursementRequestRawDto } from './wf-reimbursement-request-raw-dto';
import { WFEBankAccountResultDto } from '../../../shared-workflow-module/_models/wfe-bank-account-result-dto';

export class WFReimbursementRequestEditorResultDto {
    community: string;
    managementCompany: string;

    @Type(() => WFReimbursementRequestRawDto)
    reimbursementRawDto: WFReimbursementRequestRawDto;

    @Type(() => WFReimbursementRequestLineItemsResultDto)
    lineItems: Array<WFReimbursementRequestLineItemsResultDto>;

    @Type(() => WFEBankAccountResultDto)
    sourceBankAccounts: Array<WFEBankAccountResultDto>;

    @Type(() => WFEBankAccountResultDto)
    targetBankAccounts: Array<WFEBankAccountResultDto>;
}
